import { useEffect, useState, useMemo, useContext } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import './Admin.css';
import EditorProducto from '../components/EditorProducto';
import CrearProducto from '../components/CrearProducto';
import GaleriaImagenes from '../components/GaleriaImagenes';
import AdminCategorias from '../components/AdminCategorias';
import AdminPedidos from '../components/AdminPedidos';
import AdminUsuarios from '../components/AdminUsuarios';
import AdminStock from '../components/AdminStock';
import MenuCobro from '../components/MenuCobro';
import AdminReportes from '../components/AdminReportes';
import AdminContacto from '../components/AdminContacto';
import AdminProveedores from '../components/AdminProveedores';
import AdminCierreCaja from '../components/AdminCierreCaja';
import AdminCompras from '../components/AdminCompras';
import AdminPromociones from '../components/AdminPromociones';
import AdminDashboard from '../components/AdminDashboard';
import FiltrosBusqueda from '../components/FiltrosBusqueda';
import SelectorFondo, { useFondo } from '../components/SelectorFondo';
import Login from '../components/Login';
import { AuthContext } from '../context/AuthContext';

export default function Admin() {
  const { estaAutenticado, usuario, logout, restaurarSesion } = useContext(AuthContext);
  const [fondo, setFondo] = useFondo();

  const [muebles, setMuebles] = useState([]);
  const [filtros, setFiltros] = useState({ busqueda: '', categoria: '', precioMin: '', precioMax: '' });
  const [editorOpen, setEditorOpen] = useState(false);
  const [muebleEditando, setMuebleEditando] = useState(null);
  const [mostrarCrear, setMostrarCrear] = useState(false);
  const [mostrarCategorias, setMostrarCategorias] = useState(false);
  const [mostrarPedidos, setMostrarPedidos] = useState(false);
  const [mostrarUsuarios, setMostrarUsuarios] = useState(false);
  const [mostrarStock, setMostrarStock] = useState(false);
  const [mostrarCobro, setMostrarCobro] = useState(false);
  const [mostrarReportes, setMostrarReportes] = useState(false);
  const [mostrarContacto, setMostrarContacto] = useState(false);
  const [mostrarProveedores, setMostrarProveedores] = useState(false);
  const [mostrarCierreCaja, setMostrarCierreCaja] = useState(false);
  const [mostrarCompras, setMostrarCompras] = useState(false);
  const [mostrarPromociones, setMostrarPromociones] = useState(false);
  const [mostrarLogin, setMostrarLogin] = useState(false);
  const [confirmandoEliminar, setConfirmandoEliminar] = useState(null); // id del producto

  useEffect(() => {
    restaurarSesion();
  }, [restaurarSesion]);

  useEffect(() => {
    if (!estaAutenticado) {
      setMostrarLogin(true);
      return;
    }
    fetch('/api/productos')
      .then(r => r.json())
      .then(data => setMuebles(data))
      .catch(err => console.error('Error cargando productos:', err));
  }, [estaAutenticado]);

  const mueblesFiltrados = useMemo(() => {
    return muebles.filter(m => {
      if (filtros.busqueda && !m.nombre.toLowerCase().includes(filtros.busqueda.toLowerCase())) return false;
      if (filtros.categoria && m.categoria !== filtros.categoria) return false;
      if (filtros.precioMin !== '' && m.precio < Number(filtros.precioMin)) return false;
      if (filtros.precioMax !== '' && m.precio > Number(filtros.precioMax)) return false;
      return true;
    });
  }, [muebles, filtros]);

  const guardarProducto = (productoActualizado) => {
    setMuebles(prev => prev.map(m => m._id === productoActualizado._id ? productoActualizado : m));
    setEditorOpen(false);
    setMuebleEditando(null);
  };

  const productoCreado = (nuevo) => {
    setMuebles(prev => [nuevo, ...prev]);
    setMostrarCrear(false);
  };

  const eliminarProducto = (id) => {
    fetch(`/api/productos/${id}`, { method: 'DELETE' })
      .then(r => r.json())
      .then(() => {
        setMuebles(prev => prev.filter(m => m._id !== id));
        setConfirmandoEliminar(null);
      })
      .catch(err => console.error('Error eliminando producto:', err));
  };

  return (
    <div className="app-container">
      <header className="admin-header-nuevo">

        {/* Barra superior: ← Tienda | usuario + salir */}
        <div className="admin-topbar">
          <Link to="/" className="admin-link-tienda">← Tienda</Link>
          {estaAutenticado ? (
            <div className="admin-topbar-user">
              <SelectorFondo fondo={fondo} setFondo={setFondo} />
              <span className="admin-topbar-nombre">👤 {usuario?.nombre || 'Admin'}</span>
              <button className="admin-btn-salir" onClick={logout}>Salir</button>
            </div>
          ) : (
            <button className="btn-admin" onClick={() => setMostrarLogin(true)}>🔑 Iniciar sesión</button>
          )}
        </div>

        {/* Marca centrada */}
        <div className="admin-brand-centro">
          <h1 className="marca-nombre">lucs<span>Good</span></h1>
          <p className="marca-sub">muebles &amp; deco</p>
          <p className="admin-panel-label">panel de administración</p>
        </div>

        {/* Toolbar de acciones */}
        {estaAutenticado && (
          <nav className="admin-toolbar">
            <button className="admin-tb-btn admin-tb-cobro" onClick={() => setMostrarCobro(true)}>
              <span className="tb-icon">🛒</span>
              <span className="tb-label">Cobrar</span>
            </button>
            <button className="admin-tb-btn" onClick={() => setMostrarStock(true)}>
              <span className="tb-icon">📊</span>
              <span className="tb-label">Stock</span>
            </button>
            <button className="admin-tb-btn" onClick={() => setMostrarCategorias(true)}>
              <span className="tb-icon">🏷️</span>
              <span className="tb-label">Categorías</span>
            </button>
            <button className="admin-tb-btn" onClick={() => setMostrarPedidos(true)}>
              <span className="tb-icon">📦</span>
              <span className="tb-label">Pedidos</span>
            </button>
            <button className="admin-tb-btn" onClick={() => setMostrarUsuarios(true)}>
              <span className="tb-icon">👥</span>
              <span className="tb-label">Usuarios</span>
            </button>
            <button className="admin-tb-btn" onClick={() => setMostrarReportes(true)}>
              <span className="tb-icon">📈</span>
              <span className="tb-label">Reportes</span>
            </button>
            <button className="admin-tb-btn" onClick={() => setMostrarContacto(true)}>
              <span className="tb-icon">✉</span>
              <span className="tb-label">Contacto</span>
            </button>
            <button className="admin-tb-btn" onClick={() => setMostrarProveedores(true)}>
              <span className="tb-icon">🏭</span>
              <span className="tb-label">Proveedores</span>
            </button>
            <button className="admin-tb-btn" onClick={() => setMostrarCompras(true)}>
              <span className="tb-icon">📋</span>
              <span className="tb-label">Compras</span>
            </button>
            <button className="admin-tb-btn" onClick={() => setMostrarPromociones(true)}>
              <span className="tb-icon">📣</span>
              <span className="tb-label">Promociones</span>
            </button>
            <button className="admin-tb-btn" onClick={() => setMostrarCierreCaja(true)}>
              <span className="tb-icon">🔒</span>
              <span className="tb-label">Cierre</span>
            </button>
          </nav>
        )}

      </header>

      {estaAutenticado && (
        <>
          <AdminDashboard />
          <FiltrosBusqueda onFiltrar={setFiltros} />
          {mueblesFiltrados.length === 0 && (
            <p className="filtros-sin-resultados">No se encontraron productos con esos filtros.</p>
          )}
          <div className="productos-grid">
            {mueblesFiltrados.map(mueble => (
              <div key={mueble._id} className="producto-card">
                <GaleriaImagenes
                  imagen={mueble.imagen}
                  imagenes={mueble.imagenes}
                  nombre={mueble.nombre}
                  productoId={mueble._id}
                />
                <div className="producto-contenido">
                  <h3 className="producto-nombre">{mueble.nombre}</h3>
                  {mueble.descripcion && (
                    <p className="producto-descripcion">{mueble.descripcion}</p>
                  )}
                  {mueble.categoria && (
                    <p className="admin-producto-categoria">{mueble.categoria}</p>
                  )}
                  <p className="producto-precio">${mueble.precio?.toLocaleString('es-AR')}</p>
                  <div className="producto-botones">
                    {confirmandoEliminar === mueble._id ? (
                      <div className="admin-confirmar-eliminar">
                        <span>¿Eliminar?</span>
                        <button className="btn-confirmar-si" onClick={() => eliminarProducto(mueble._id)}>Sí</button>
                        <button className="btn-confirmar-no" onClick={() => setConfirmandoEliminar(null)}>No</button>
                      </div>
                    ) : (
                      <>
                        <button
                          className="btn-editar admin-activo admin-btn-full"
                          onClick={() => { setMuebleEditando(mueble); setEditorOpen(true); }}
                        >
                          ✎ Editar
                        </button>
                        <button
                          className="btn-eliminar admin-btn-full"
                          onClick={() => setConfirmandoEliminar(mueble._id)}
                        >
                          🗑 Eliminar
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Modales */}
      <EditorProducto
        mueble={muebleEditando}
        isOpen={editorOpen}
        onClose={() => { setEditorOpen(false); setMuebleEditando(null); }}
        onSave={guardarProducto}
      />
      <CrearProducto
        isOpen={mostrarCrear}
        onClose={() => setMostrarCrear(false)}
        onCrear={productoCreado}
      />
      <AdminCategorias
        isOpen={mostrarCategorias}
        onClose={() => setMostrarCategorias(false)}
      />
      <AdminPedidos
        isOpen={mostrarPedidos}
        onClose={() => setMostrarPedidos(false)}
      />
      <AdminUsuarios
        isOpen={mostrarUsuarios}
        onClose={() => setMostrarUsuarios(false)}
      />
      <AdminStock
        isOpen={mostrarStock}
        onClose={() => setMostrarStock(false)}
        onNuevo={() => { setMostrarStock(false); setMostrarCrear(true); }}
      />
      <MenuCobro
        isOpen={mostrarCobro}
        onClose={() => setMostrarCobro(false)}
      />
      <AdminReportes
        isOpen={mostrarReportes}
        onClose={() => setMostrarReportes(false)}
      />
      <AdminContacto
        isOpen={mostrarContacto}
        onClose={() => setMostrarContacto(false)}
      />
      <AdminProveedores
        isOpen={mostrarProveedores}
        onClose={() => setMostrarProveedores(false)}
      />
      <AdminCierreCaja
        isOpen={mostrarCierreCaja}
        onClose={() => setMostrarCierreCaja(false)}
      />
      <AdminCompras
        isOpen={mostrarCompras}
        onClose={() => setMostrarCompras(false)}
      />
      <AdminPromociones
        isOpen={mostrarPromociones}
        onClose={() => setMostrarPromociones(false)}
      />
      {mostrarLogin && (
        <Login onClose={() => setMostrarLogin(false)} />
      )}
    </div>
  );
}
